module.exports = __webpack_public_path__ + "static/media/수락산.5bc8f8fd.jpg";